import React, { useEffect, useState } from 'react';
import PrepModeComponent from '../../components/Mode/PrepModeComponent';
import UpdateForecast from '../Forecast/UpdateForecast';
import Swal from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router-dom';
import { hasMultipleRoles, hasMultipleProperties, hasDifferentRoleOrProperty } from '../../../services/common.utils';
import { useDispatch } from 'react-redux';
import { Logout } from '../../../store/actions/AuthActions';
import FunctionTimeSegmentsReport from '../Reports/FunctionTimeSegmentsReport';

function DashboardIndex() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userRole = JSON.parse(localStorage.getItem('selectedLoginData'));
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const userDetailsAll = JSON.parse(localStorage.getItem('userDetailsAll'));

    const roles = userDetails?.find(e => parseInt(e?.roles_id) === parseInt(userRole.role_id));
    let hasDifferentRolesData = hasDifferentRoleOrProperty(userDetailsAll?.properties_roles);
    const [isPopupVisible, setPopupVisible] = useState(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const popupVisible = queryParams.get('cp') === '1';
        setPopupVisible(popupVisible);

        // console.log('Query Params:', queryParams);
        // console.log('Popup Visible:', popupVisible);
    }, [location.search]);

    // useEffect(() => {
    //     if (userDetailsAll && !isPopupVisible) {
    //         console.log('User Details All:', userDetailsAll);
    //         console.log('Is Popup Visible:', isPopupVisible);
    //         if (userDetailsAll?.login_type !== 'simple') {
    //             setPopupVisible(isPopupVisible);
    //         }
    //     }
    // }, [isPopupVisible, userDetailsAll]);

    useEffect(() => {
        // console.log('Popup Visible:', isPopupVisible);
        let hasMultiplePropertiesData = hasMultipleProperties(userDetailsAll?.properties_roles);
        let hasMultipleRolesData = hasMultipleRoles(userDetailsAll?.properties_roles);

        if (isPopupVisible && hasDifferentRolesData) {
            let title = hasMultiplePropertiesData && hasMultipleRolesData ? 'Change Property & Role' :
                hasMultiplePropertiesData && !hasMultipleRolesData ? 'Change Property' :
                    !hasMultiplePropertiesData && hasMultipleRolesData ? 'Change Role' : 'Change Property & Role';
            let desc = hasMultiplePropertiesData && hasMultipleRolesData ? 'Update your settings for Property & Role' :
                hasMultiplePropertiesData && !hasMultipleRolesData ? 'Update your settings for Change Property' :
                    !hasMultiplePropertiesData && hasMultipleRolesData ? 'Update your settings for Change Role' : 'Update your settings for Change Property & Role';

            // console.log('Title:', title);
            // console.log('Description:', desc);

            // show alert
            Swal.fire({
                title: title,
                text: desc,
                showCancelButton: true,
                confirmButtonText: title,
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
            }).then((result) => {
                setPopupVisible(false);
                if (result.isConfirmed) {
                    // Handle the Change property action
                    navigate('/change-property');
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Handle the Cancel action
                    console.log('Cancel clicked');
                }
            });
        }
    }, [hasDifferentRolesData, isPopupVisible, navigate]);

    if (!roles) return null;

    return (
        (roles.role_name === 'executive housekeeper' || roles.role_name === 'housekeeping supervisor') ?
            // <UpdateForecast />
            <FunctionTimeSegmentsReport />
            :
            <PrepModeComponent />
    );
}

export default DashboardIndex;
